import { ItemRevisionDataset } from './item-revision-dataset';
import { ItemRevisionProject } from './item-revision-project';
import { ItemRevisionReference } from './item-revision-reference';

export class ItemRevision {
  public constructor(
    public datasets: ItemRevisionDataset[],
    public projects: ItemRevisionProject[],
    public references: ItemRevisionReference[],
    public releaseStatus: string,
    public revId: string,
    public chgShortNote: string,
    public revDesc: string,
    public chgNote: string,
    public chgNumber: string,
    public weight?: string
  ) {}
}
